
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Account"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAccountManager"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspectionStartTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotImportGroupRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dealerUniqueIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetUniqueIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotImportMakeTypeRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotImporterVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotSearchableMetaFields"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapshotImporterInspectionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultAccountManagerFilter"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"availableRoles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rights"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canSwitchToEntities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"culture"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thousandSeparator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"decimalSeparator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateNotation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeNotation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"systemOfMeasurement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rateFromEUR"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":764}};
    doc.loc.source = {"body":"query Account {\n  account {\n    id\n    name\n    email\n\n    isAccountManager\n\n    entity {\n      id\n      name\n      config {\n        inspectionStartTime\n        snapshotImportGroupRequired\n        dealerUniqueIdentifier\n        assetUniqueIdentifier\n        snapshotImportMakeTypeRequired\n        snapshotImporterVersion\n        snapshotSearchableMetaFields\n        snapshotImporterInspectionType\n        defaultAccountManagerFilter\n      }\n\n      availableRoles {\n        id\n        name\n      }\n    }\n\n    rights\n\n    canSwitchToEntities {\n      id\n      name\n    }\n\n    culture {\n      thousandSeparator\n      decimalSeparator\n      dateNotation\n      timeNotation\n      systemOfMeasurement\n      currency {\n        code\n        rateFromEUR\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Account"] = oneQuery(doc, "Account");
        
